export const MODAL_ID = 'job-locked';

export const CLASS_NAMES = {
  title: 'text-style-b mb-4 text-neutral-900',
  description:
    'text-style-g text-neutral-700 whitespace-pre-line md:text-style-f md:text-neutral-600',
  contentWrapper: 'flex flex-col m-auto text-center py-2 text-center',
  icon: 'mx-auto',
  sentWrapper: 'text-purple-200 flex flex-row items-center gap-x-2 mx-auto',
  sentText: 'text-style-h-em',
  sentIcon: 'w-2',
  sendWrapper: 'mt-4 flex items-center justify-center',
};

export const COPY = {
  unlocked: {
    title: 'Verify your email',
    description:
      'Verify your email address to apply for credit. Follow the link in the email Kanda just sent you. Search kanda.co.uk to find it.',
  },
  locked: {
    title: 'Check your email',
    description:
      'To view this job follow the link we sent to your email. Search kanda.co.uk to find it.',
  },
};
